/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Drop_Frame_Convert_HelpInputs */

const en_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This option is valid when converting from a format that uses SMPTE timecode (e.g. SCC, MCC, etc.) to an offset timecode format (e.g. SRT, WebVTT, etc.)`)
};

const fr_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette option est valide lors de la conversion depuis un format utilisant le timecode SMPTE (ex. SCC, MCC, etc.) vers un format de timecode decale (ex. SRT, WebVTT, etc.)`)
};

const de_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Option ist gültig bei der Konvertierung von einem Format, das SMPTE-Timecode verwendet (z. B. SCC, MCC usw.), in ein Offset-Timecode-Format (z. B. SRT, WebVTT usw.).`)
};

const it_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa opzione è valida quando si esegue la conversione da un formato che utilizza il timecode SMPTE (ad esempio SCC, MCC, ecc.) a un formato di timecode offset (ad esempio SRT, WebVTT, ecc.)`)
};

const ru_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эта опция действительна при преобразовании из формата, использующего временной код SMPTE (например, SCC, MCC и т. д.), в формат временного кода со смещением (например, SRT, WebVTT и т. д.).`)
};

const es_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta opción es válida al convertir de un formato que utiliza código de tiempo SMPTE (por ejemplo, SCC, MCC, etc.) a un formato de código de tiempo desplazado (por ejemplo, SRT, WebVTT, etc.)`)
};

const zh_cn2_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当从使用 SMPTE 时间码的格式（例如 SCC、MCC 等）转换为偏移时间码格式（例如 SRT、WebVTT 等）时，此选项有效。`)
};

const ja_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このオプションは、SMPTE タイムコードを使用する形式 (SCC、MCC など) からオフセット タイムコード形式 (SRT、WebVTT など) に変換する場合に有効です。`)
};

const hi_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह विकल्प तब मान्य होता है जब SMPTE टाइमकोड (जैसे SCC, MCC, आदि) का उपयोग करने वाले प्रारूप से ऑफसेट टाइमकोड प्रारूप (जैसे SRT, WebVTT, आदि) में रूपांतरण किया जा रहा हो।`)
};

const pt_pt2_subtitle_import_drop_frame_convert_help = /** @type {(inputs: Subtitle_Import_Drop_Frame_Convert_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa opção é válida ao converter de um formato que usa código de tempo SMPTE (por exemplo, SCC, MCC, etc.) para um formato de código de tempo com deslocamento (por exemplo, SRT, WebVTT, etc.).`)
};

/**
* | output |
* | --- |
* | "This option is valid when converting from a format that uses SMPTE timecode (e.g. SCC, MCC, etc.) to an offset timecode format (e.g. SRT, WebVTT, etc.)" |
*
* @param {Subtitle_Import_Drop_Frame_Convert_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_drop_frame_convert_help = /** @type {((inputs?: Subtitle_Import_Drop_Frame_Convert_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Drop_Frame_Convert_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_import_drop_frame_convert_help(inputs)
	if (locale === "de") return de_subtitle_import_drop_frame_convert_help(inputs)
	if (locale === "it") return it_subtitle_import_drop_frame_convert_help(inputs)
	if (locale === "ru") return ru_subtitle_import_drop_frame_convert_help(inputs)
	if (locale === "es") return es_subtitle_import_drop_frame_convert_help(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_import_drop_frame_convert_help(inputs)
	if (locale === "ja") return ja_subtitle_import_drop_frame_convert_help(inputs)
	if (locale === "hi") return hi_subtitle_import_drop_frame_convert_help(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_import_drop_frame_convert_help(inputs)
	return en_subtitle_import_drop_frame_convert_help(inputs)
});